import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { upperFirst } from 'lodash';
import styled, { css } from 'styled-components';
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { DefaultLinkSimple } from "../../link/src";
import { primaryShadow, useTheme } from "../../theme/src";
import { getSocialButtonsTheme } from './utils';
export const SUPPORTED_ICONS = Object.freeze({
    angellist: {
        color: 'asphalt',
        iconName: 'angellist',
        iconType: CATEGORIES.BRANDS,
        key: 'angellist',
    },
    blackberry: {
        color: 'white',
        iconName: 'blackberry',
        iconType: CATEGORIES.BRANDS,
        key: 'blackberry',
    },
    facebook: {
        color: 'white',
        iconName: 'facebook',
        iconType: CATEGORIES.BRANDS,
        key: 'facebook',
    },
    flickr: {
        color: 'asphalt',
        iconName: 'flickr',
        iconType: CATEGORIES.BRANDS,
        key: 'flickr',
    },
    globe: {
        color: 'white',
        iconName: 'globe',
        iconType: CATEGORIES.REGULAR,
        key: 'globe',
    },
    instagram: {
        color: 'asphalt',
        iconName: 'instagram',
        iconType: CATEGORIES.BRANDS,
        key: 'instagram',
    },
    linkedin: {
        color: 'white',
        iconName: 'linkedin-in',
        iconType: CATEGORIES.BRANDS,
        key: 'linkedin',
    },
    pinterest: {
        color: 'white',
        iconName: 'pinterest',
        iconType: CATEGORIES.BRANDS,
        key: 'pinterest',
    },
    rssfeed: {
        color: 'mandarine',
        iconName: 'rss',
        iconType: CATEGORIES.REGULAR,
        key: 'rssfeed',
    },
    skype: {
        color: 'white',
        iconName: 'skype',
        iconType: CATEGORIES.BRANDS,
        key: 'skype',
    },
    twitter: {
        color: 'white',
        iconName: 'x-twitter',
        iconType: CATEGORIES.BRANDS,
        key: 'twitter',
    },
    viadeo: {
        color: 'white',
        iconName: 'viadeo',
        iconType: CATEGORIES.BRANDS,
        key: 'viadeo',
    },
    xing: {
        color: 'white',
        iconName: 'xing',
        iconType: CATEGORIES.BRANDS,
        key: 'xing',
    },
    youtube: {
        color: '#FF0000',
        iconName: 'youtube',
        iconType: CATEGORIES.BRANDS,
        key: 'youtube',
    },
});
export const SocialButton = (_a) => {
    var _b, _c;
    var { dataTestId, title = '', type, url } = _a, otherProps = __rest(_a, ["dataTestId", "title", "type", "url"]);
    const theme = useTheme();
    const socialName = upperFirst(type);
    const iconProps = SUPPORTED_ICONS[type];
    const testId = dataTestId || 'ds-m-social-button';
    let linkTitle = socialName;
    if (title) {
        linkTitle =
            ((_c = (_b = window === null || window === void 0 ? void 0 : window.s__) === null || _b === void 0 ? void 0 : _b.call(window, 'SocialLinks|%{title} on %{social_network}')) === null || _c === void 0 ? void 0 : _c.i__({
                social_network: socialName,
                title,
            })) || socialName;
    }
    if (Object.keys(SUPPORTED_ICONS).includes(type)) {
        const socialButtonsTheme = getSocialButtonsTheme(theme);
        const socialButtonTheme = socialButtonsTheme[type] || socialButtonsTheme.default;
        if (url) {
            return (_jsx(ButtonLink, Object.assign({ "data-testid": testId, href: url, socialButtonTheme: socialButtonTheme, target: "_blank", title: linkTitle }, otherProps, { children: _jsx(FontAwesomeIcon, { color: iconProps.color, "data-testid": testId, height: "18px", iconName: iconProps.iconName, iconType: iconProps.iconType }) })));
        }
        return (_jsx(ButtonIcon, Object.assign({ "data-testid": testId, socialButtonTheme: socialButtonTheme, title: title }, otherProps, { children: _jsx(FontAwesomeIcon, { color: iconProps.color, "data-testid": testId, height: "18px", iconName: iconProps.iconName, iconType: iconProps.iconType }) })));
    }
    return (_jsx(DefaultLinkSimple, Object.assign({ "data-testid": testId, href: url, target: "_blank", title: linkTitle }, otherProps, { children: title })));
};
const BaseButton = css `
  ${primaryShadow}
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 3px;
  transition: background 300ms ease;
  background: ${({ socialButtonTheme }) => socialButtonTheme.background};

  &:focus,
  &:hover {
    background: ${({ socialButtonTheme }) => socialButtonTheme.hover.background};
  }
`;
const ButtonLink = styled(DefaultLinkSimple).withConfig({
    shouldForwardProp: (prop) => !['socialButtonTheme'].includes(prop),
}) `
  ${BaseButton}
`;
const ButtonIcon = styled(Box).withConfig({
    shouldForwardProp: (prop) => !['socialButtonTheme'].includes(prop),
}) `
  ${BaseButton}
`;
//# sourceMappingURL=SocialButton.js.map